import styled from 'styled-components';

import {
  Content as ModalContent,
  Header as ModalHeader,
} from '~/components/Modal/styles';
import { WEDO_DEFAULT_WIDTH } from '~/styles/breakpoints';
import grid from '~/styles/grid';

import colors from '../../styles/colors';

export const Container = styled.div`
  top: 0;
  position: sticky;
  width: 100vw;
  height: 80px;
  background: linear-gradient(
    to right,
    ${colors.primary},
    ${colors.darkprimary}
  );
  padding: 0 0 5px 0;
  z-index: 5000;

  ${ModalContent} {
    max-width: 450px;
    padding: ${grid.lg};
  }

  ${ModalHeader} {
    text-align: center;

    span {
      font-size: 18px;
      font-weight: bold;
      color: #4d4d4d;
      margin-bottom: ${grid.sm};
    }

    &:after {
      display: none;
    }
  }
`;

export const SubContainer = styled.div`
  background: ${colors.white};
  height: 75px;
  width: 100%;
  display: flex;
`;

export const Content = styled.div`
  display: grid;
  width: 100%;
  max-width: ${WEDO_DEFAULT_WIDTH};
  grid-template-columns: min-content auto min-content;
  margin: auto;
`;

export const LogoContent = styled.div``;

export const NavigationMenuContent = styled.div`
  margin: auto;
`;

export const Nav = styled.ul`
  list-style: none;
  display: flex;
  column-gap: ${grid.lg};

  li {
    a {
      color: inherit;
      font-size: 114.28%;
    }
    .active {
      font-weight: bold;
      color: #cc003d;
    }

    &:hover {
      color: #cc003d;
    }
  }
`;

export const UserMenuContent = styled.div`
  margin: auto;
`;

export const UserMenu = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;

  .MuiSvgIcon-root {
    font-size: 1.8rem;
  }
`;

export const FirstAccessText = styled.span`
  color: ${colors.primary};
`;
